import React, { useState, useEffect } from 'react'
import { Button, Col, Form, Row, Table } from 'react-bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import ApiEndpoints, {BASE_URL} from './commonComponents/ApiEndpoints'
import { FaArrowLeft, FaEdit, FaPrint, FaSyncAlt } from 'react-icons/fa'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import toast from 'react-hot-toast'
import Cookies from 'js-cookie'
import axios from 'axios'
import EditTransactionModal from './commonComponents/EditTransactionModal'
// import { Typeahead } from 'react-bootstrap-typeahead'

export default function StudentFees() {
  const [marginLeft, setMarginLeft] = useState(
    window.innerWidth > 768 ? '300px' : '0px',
  )
  const location = useLocation()
  const {
    selectedStudent: navStudent,
    selectedFees: navFees,
    selectedData: navData,
    selectedStudentId: navStudentId,
    selectedClassId: navClassId,
    selectedCourseId: navCourseId,
  } = location.state || {}
  console.log('NAVIGATION DATA ', location.state)
  console.log('navStudent:', navStudent)
  console.log('navFees:', navFees)
  console.log('navData:', navData)
  console.log('navStudentId:', navStudentId)
  console.log('navClassId:', navClassId)
  console.log('navCourseId:', navCourseId)
  const { student_id, course_id } = useParams()
  const actualCourseId =
    course_id === 'null' || course_id === '_' ? null : course_id
  console.log('actualCourseId', actualCourseId)

  console.log('Student ID:', student_id)
  const [selectedFees, setSelectedFees] = useState([])
  const [openTable, setOpenTable] = useState(false)
  const [courses, setCourses] = useState([])
  const [classes, setClasses] = useState([])
  const [allStudents, setAllStudents] = useState([])
  const [filteredStudents, setFilteredStudents] = useState([])
  const [selectedStudent, setSelectedStudent] = useState(null)
  const [selectedData, setSelectedData] = useState([])
  const [selectedCourseId, setSelectedCourseId] = useState(null)
  const [selectedStudentId, setSelectedStudentId] = useState(null)
  const [selectedClassId, setSelectedClassId] = useState(null)
  const [hasModifiedFields, setHasModifiedFields] = useState(false)
  const [currentStudent, setCurrentStudent] = useState(null)
  const [selectedStudentIdParams, setSelectedStudentIdParams] = useState(null)
  const [selectedTransactionId, setSelectedTransactionId] = useState(null)
  const [openEditModal, setOpenEditModal] = useState(null)
  
  const handleSelectFee = (feeId) => {
    setSelectedFees((prev) =>
      prev.includes(feeId)
        ? prev.filter((id) => id !== feeId)
        : [...prev, feeId],
    )
  }

      const fetchStudentFeeData = async () => {
      try {
        const res = await ApiEndpoints.getAllFeesByStudentProfileId(student_id)
        // console.log('student:', res.data.student)
        console.log('student:', res)

        console.log('fees:', res.data.fees)
        // console.log('selectedStudent:', res.data.selectedStudent)
        console.log('Response from params:', res.data.data)

        console.log('student_id', student_id)
        // setSelectedStudentIdParams(student_id)

        setSelectedStudentId(student_id)
        // setSelectedCourseId(course_id)
        // setSelectedClassId(class_id)

        setSelectedData(res.data.fees || res.data.data || [])

        setOpenTable(true)
      } catch (err) {
        console.error('Failed to fetch student fee data:', err)
      }
    }

  useEffect(() => {
    if (navStudent && navData) {
      setSelectedStudent(navStudent)
      setSelectedData(navData)
      setOpenTable(true)
    } else if (student_id) {
      fetchStudentFeeData()
    }
  }, [navStudent, navData, student_id])

  useEffect(() => {
    if (navStudent) {
      setSelectedStudent(navStudent)
    }
    if (navFees) {
      setSelectedFees(navFees)
    }
    if (navData) {
      setSelectedData(navData)
      setOpenTable(true)
    }

    if (navStudentId || student_id) {
      setSelectedStudentId(navStudentId || student_id)
    }
    if (navClassId) {
      setSelectedClassId(navClassId)
    }
    if (navCourseId) {
      setSelectedCourseId(navCourseId)
    }
  }, [
    navStudent,
    navFees,
    navData,
    navStudentId,
    navCourseId,
    navClassId,
    student_id,
  ])

  useEffect(() => {
    if (student_id && selectedFees?.length > 0) {
      // const foundStudent = allStudents.find((s) => s.id === Number(student_id))
      // if (foundStudent) {
      //   setSelectedStudent(foundStudent)
      console.log('Student ID during fetch:', student_id)
      //   console.log('Course ID during fetch:', course_id)
      //   console.log('Class ID during fetch:', class_id)

      //   setSelectedCourseId(course_id)
      setSelectedStudentId(student_id)
      //   setSelectedClassId(class_id)
      setOpenTable(true)

      // Fetch fees
      ApiEndpoints.getAllFeesByStudentId(student_id)
        .then((res) => {
          setSelectedData(res.data.data)
        })
        .catch((error) => {
          console.error('Failed to load fees:', error)
          setSelectedData([])
        })
      // }
    }
  }, [student_id])

  //   useEffect(() => {
  //     if (selectedCourseId) {
  //       ApiEndpoints.getAllClassesByCourseId(selectedCourseId)
  //         .then((res) => {
  //           const { data } = res
  //           if (data.status === false || !data.data?.length) {
  //             setClasses([])
  //           } else {
  //             setClasses(data.data)
  //             // setSelectedClassId(classId)
  //           }
  //         })
  //         .catch(() => {
  //           setClasses([])
  //         })
  //     }
  //   }, [selectedCourseId])
  useEffect(() => {
    const institueId = Cookies.get('institute_id')
    const userCookie = Cookies.get('user')
    let token = null
    console.log('InstituteID', institueId)

    if (userCookie) {
      try {
        const user = JSON.parse(userCookie)
        token = user.token
        console.log('TOKEN:', token)
      } catch (err) {
        console.error(' Failed to parse user cookie', err)
      }
    } else {
      console.warn('user cookie not found')
    }

    // const fetchFilteredData = async () => {
    //   console.log('Insti ID: ', institueId)
    //   try {
    //     const headers = {
    //       'Content-Type': 'application/json',
    //       Authorization: `Bearer ${token}`,
    //       institute_id: Number(institueId),
    //     }

    //     console.log('Request Headers:', headers)

    //     const response = await axios.get(
    //       BASE_URL+'/student/all',
    //       { headers },
    //     )

    //     const studentRes = response.data.data
    //     console.log('Students response: ', studentRes)
    //     const studentId = student_id // the ID you want to search for
    //     const student = studentRes.find(
    //       (st) => Number(st.id) === Number(studentId),
    //     )
    //     const name = student || 'N/A'
    //     console.log('Select Student data:', name)
    //     const studentParId = studentRes.find(
    //       (st) => Number(st.id) === Number(student_id),
    //     )
    //     console.log('studentParId with data', studentParId)

    //     const studentParNameId = studentParId
    //     console.log('studentParId:', studentParNameId.id)
    //     console.log('studentParNameId:', studentParNameId?.name)

    //     setFilteredStudents(studentParId)
    //     setSelectedStudentIdParams(studentParId)

    //     setAllStudents(response.data.data)
    //     setSelectedStudent(name)
    //     // setData(response.data.data)
    //   } catch (error) {
    //     toast.error(error.response?.data?.message || 'Something went wrong')
    //   }
    // }
    const fetchFilteredData = async () => {
      console.log('Insti ID: ', institueId)
      try {
        const headers = {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
          institute_id: Number(institueId),
        }
        console.log('Request Headers:', headers)

        const res = await axios.get(
          BASE_URL+'/student/all',
          { headers },
        )
        const students = res.data.data
        console.log('Students response: ', students)

        const student =
          students.find((st) => Number(st.id) === Number(student_id)) || 'N/A'
        console.log('Select Student data:', student)

        const studentParId = students.find(
          (st) => Number(st.id) === Number(student_id),
        )
        console.log('studentParId with data', studentParId)
        console.log('studentParId:', studentParId?.id)
        console.log('studentParNameId:', studentParId?.name)

        setFilteredStudents(studentParId)
        setSelectedStudentIdParams(studentParId)
        setAllStudents(students)
        setSelectedStudent(student)
      } catch (error) {
        toast.error(error.response?.data?.message || 'Something went wrong')
      }
    }

    fetchFilteredData()
  }, [])
  //   useEffect(() => {
  //     ApiEndpoints.getAllCourses()
  //       .then((res) => setCourses(res.data.data))
  //       .catch(console.error)
  //   }, [])

  //   useEffect(() => {
  //     if (course_id) {
  //       handleCourseChange({ target: { value: course_id } })
  //     }
  //   }, [course_id])

  //   useEffect(() => {
  //     if (class_id && allStudents.length > 0) {
  //       handleClassChange({ target: { value: class_id } })
  //     }
  //   }, [class_id, allStudents])

  useEffect(() => {
    if (student_id && filteredStudents?.length > 0) {
      const student = filteredStudents.find((s) => s.id === Number(student_id))
      console.log('student ..........', student)

      if (student) {
        setSelectedStudentId(student.id)

        setSelectedStudent(student)
        // console.log('setSelectedStudentId', student.id)
        // console.log('setSelectedStudentIdParams', student.id)
        console.log('setSelectedStudent', student.id)
      }
    }
    // else if (selectedStudentIdParams && filteredStudents.length > 0) {
    //   const student = filteredStudents.find((s) => s.id === Number(student_id))
    //   console.log('student from params', student)
    // }
  }, [student_id, filteredStudents])

  useEffect(() => {
    if (!location.state) {
      // Hard refresh happened - clear everything manually
      setSelectedStudent(null)
      setSelectedFees([])
      setSelectedData([])
      setSelectedCourseId(null)
      setSelectedClassId(null)
      setSelectedStudentId(null)
      setOpenTable(false)
    }
  }, [location.state])

  //   const handleCourseChange = async (e) => {
  //     setHasModifiedFields(true)
  //     const courseId = e.target.value
  //     setSelectedCourseId(courseId)
  //     setClasses([])
  //     setFilteredStudents([])
  //     setSelectedData([])
  //     setSelectedStudentId(null)
  //     setSelectedClassId(null)
  //     setSelectedStudent(null)

  //     // console.log('courseId ', courseId, 'and', 'course_id', course_id)
  //     setOpenTable(true)
  //     if (courseId) {
  //       const res = await ApiEndpoints.getAllClassesByCourseId(courseId)
  //       setClasses(res.data.data)
  //     }
  //     if (courseId) {
  //       ApiEndpoints.getAllClassesByCourseId(courseId)
  //         .then((res) => {
  //           const { data } = res
  //           if (data.status === false || !data.data?.length) {
  //             toast.error('No classes found for this course.')
  //             setClasses([])
  //             setOpenTable(false)
  //           } else {
  //             setClasses(data.data)
  //           }
  //         })
  //         .catch((error) => {
  //           // This is where 404 or other errors come
  //           if (
  //             error.response?.data?.message === 'No classes found for this course'
  //           ) {
  //             toast.error('No classes found for this course.')
  //           } else {
  //             console.error('Error fetching classes:', error)
  //             toast.error('Something went wrong while fetching classes.')
  //           }
  //           setClasses([])
  //         })
  //     }
  //   }

  //   const handleClassChange = (e) => {
  //     setHasModifiedFields(true)
  //     const classId = e.target.value

  //     const filtered = allStudents.filter(
  //       (student) => student.class_id === Number(classId),
  //     )
  //     console.log('filtered', filtered)
  //     // setFilteredStudents(filtered)
  //     setSelectedClassId(classId)
  //     setSelectedStudentId(null)
  //     setSelectedStudent(null)
  //     setSelectedData([])
  //     setSelectedFees([])
  //     setOpenTable(true)

  //     if (classId) {
  //       const institueId = Cookies.get('institute_id')
  //       const headers = {
  //         institute_id: Number(institueId),
  //       }
  //       axios
  //         .get(
  //           BASE_URL+`/get/student/by-class?class_id=${classId}`,
  //           { headers },
  //         )
  //         .then((res) => {
  //           console.log('Students after class select:', res.data.data)
  //           setFilteredStudents(res.data.data)
  //         })
  //         .catch((error) => {
  //           // This is where 404 or other errors come
  //           if (
  //             error.response?.data?.message === 'No classes found for this course'
  //           ) {
  //             console.error('No classes found for this course.')
  //           } else {
  //             console.error('Error fetching classes:', error)
  //             console.error('Something went wrong while fetching classes.')
  //           }
  //           setClasses([])
  //         })
  //     }
  //   }
  useEffect(() => {
    if (selectedCourseId && selectedStudentId) {
      ApiEndpoints.getAllFeesByStudentProfileId(student_id)
        .then((res) => {
          console.log('Response:', res.data.data)
          setSelectedData(res.data.data)
          setOpenTable(true)
        })
        .catch((err) => {
          console.error('Failed to fetch fees', err)
          setSelectedData([])
        })
    }
    // }
  }, [student_id])

  //   const handleStudentChange = async (e) => {
  //     setHasModifiedFields(true)
  //     const studentId = e.target.value
  //     setSelectedStudentId(studentId)
  //     // setOpenTable(true)
  //     const student = filteredStudents.find((s) => s.id === Number(studentId))
  //     setSelectedStudent(student)
  //     setSelectedFees([])
  //     setOpenTable(true)

  //     if (selectedStudentId && selectedCourseId) {
  //       try {
  //         const res = await ApiEndpoints.getAllFeesByStudentId(
  //           selectedStudentId,
  //           selectedCourseId,
  //         )
  //         console.log('Last response:', res.data.data)

  //         setSelectedData(res.data.data) // Store fees data properly
  //       } catch (error) {
  //         console.error('Error fetching fees:', error.response?.data?.message)
  //         // toast.error(error.response?.data?.message)
  //         setSelectedData([])
  //       }
  //     }
  //   }

  useEffect(() => {
    const handleResize = () => {
      setMarginLeft(window.innerWidth > 768 ? '270px' : '0px')
    }

    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [])

  const navigate = useNavigate()
  const handlePrint = (fee) => {
    if (!selectedStudent && !selectedStudentIdParams?.id) {
      toast.error('Select a student to print the receipt.')
      return
    }

    const studentId = selectedStudent?.id || student_id
    const feeIdsParam = selectedFees.length ? selectedFees.join(',') : fee?.id

    const stateData = {
      fee,
      selectedStudent,
      selectedFees: selectedFees.length ? selectedFees : [fee?.id],
      selectedData,
      selectedCourseId,
      selectedClassId,
      selectedStudentId,
      selectedStudentIdParams,
    }
    console.log('State Data:', stateData)
    navigate(`/FeeRecipt/${studentId}/${feeIdsParam}`, {
      state: stateData,
    })
  }

  const handleBack = (studentId) => {
    if (!studentId) {
      toast.error('No student selected. Please select a student first')
      return
    }
    navigate(`/StudentProfile/${studentId}`)
  }

  const handleTakeFeesButton = () => {
    if (!student_id) {
      toast.error('Student is not selected')
      return
    }

    if (!selectedCourseId) {
      // If course is optional, you can still navigate with just studentId
      navigate(`/TakeFees/${student_id}`)
    } else {
      // Full route with both course and student
      navigate(`/TakeFees/${actualCourseId}/${student_id}`)
    }
  }

  console.log('selectedStudentId:', selectedStudentId)
  console.log('selectedCourseId:', selectedCourseId)
  console.log('selectedStudentIdParams:', selectedStudentIdParams?.id)
  console.log('selectedStudentIdParamsName:', selectedStudentIdParams?.name)

  console.log('student_id:', student_id)

  return (
    <>
      <style>
        {`
        .hover-white:hover{
        color:white !important;
        }
      `}
      </style>
      <div style={{ marginLeft }}>
        <div
          className="container-fluid p-0"
          style={{ marginTop: window.innerWidth < 768 ? '55px' : '-11px' }}
        >
          <h2 className="bg-secondary p-3 rounded text-white fw-bold text-start">
            See Student Fees{' '}
            {(selectedStudent?.name?.toUpperCase() ||
              selectedStudentIdParams?.name?.toUpperCase()) && (
              <>
                for{' '}
                <span className="text-warning">
                  {selectedStudent?.name?.toUpperCase() ||
                    selectedStudentIdParams?.name?.toUpperCase()}
                </span>
              </>
            )}
          </h2>
        </div>

        {/* <div className="d-flex flex-nowrap gap-3">

      </div> */}

        {openTable && (
          <div className="mt-4 text-start">
            <div className="d-flex justify-content-between align-items-center mt-4 mb-3">
              {/* {student_id && (
                <div>
                  <Button onClick={() => handleBack(selectedStudent?.id)}>
                    <FaArrowLeft /> Go to{' '}
                    <span className="fw-bold">{selectedStudent?.name}</span>{' '}
                    profile
                  </Button>
                </div>
              )} */}

              {/* <div className="ms-auto gap-2 d-flex">
                <Button
                  variant="outline-dark"
                  className="text-danger fw-bold hover-white"
                  onClick={() => handleTakeFeesButton()}
                  // disabled={selectedData.length === 0}
                >
                  💰 Take Fees
                </Button>
                <button
                  onClick={() => handlePrint()}
                  className="btn btn-primary"
                  disabled={selectedFees.length === 0}
                >
                  <FaPrint className="me-2" />
                  Print Receipt
                </button>
              </div> */}
            </div>
            <Table striped bordered hover>
              <thead>
                <tr>
                  {/* <th>Select Rows</th> */}
                  <th>Fees Name</th>
                  <th>Course</th>
                  <th>Amount in Rupees</th>
                  <th>Start Date</th>
                  <th>End Date</th>
                  <th>Transaction ID</th>
                  <th>Transaction Amount</th>
                  <th>Discount</th>
                  <th>Payment Method</th>
                  <th>Transaction Date</th>
                  <th>Fees Status</th>
                  {/* <th>Action</th> */}
                </tr>
              </thead>
              <tbody>
                {/* Check if a student is selected */}
                {!student_id && selectedData.length === 0 ? (
                  <tr>
                    <td colSpan="11 text-danger" className="text-center">
                      No data found
                    </td>
                  </tr>
                ) : (
                  selectedData
                    .filter(
                      (fee) =>
                        fee.fees_status === 'pending' ||
                        fee.fees_status === 'complete',
                    )
                    .map((fee) => (
                      <tr key={fee.id}>
                        {/* <td className="text-center">
                          {fee.fees_status === 'complete' && (
                            <input
                              style={{
                                cursor: 'pointer',
                                width: '20px',
                                height: '20px',
                              }}
                              type="checkbox"
                              onChange={() => handleSelectFee(fee.id)} // Update to select individual fees
                              checked={selectedFees.includes(fee.id)} // Check if this fee is selected
                            />
                          )}
                        </td> */}

                        <td>
                          {fee.fees_name?.charAt(0).toUpperCase() +
                            fee.fees_name?.slice(1)}
                        </td>
                        <td>{fee.course_name}</td>
                        <td>₹ {fee.amount}</td>
                        <td>
                          {new Date(fee.start_date).toLocaleDateString(
                            'en-GB',
                            {
                              day: '2-digit',
                              month: 'long',
                              year: 'numeric',
                            },
                          )}
                        </td>
                        <td>
                          {new Date(fee.end_date).toLocaleDateString('en-GB', {
                            day: '2-digit',
                            month: 'long',
                            year: 'numeric',
                          })}
                        </td>
                        <td>{fee.transaction_id || ''}</td>
                        <td>
                          {' '}
                          {fee.transaction_amount
                            ? `₹${fee.transaction_amount}`
                            : ' '}
                        </td>
                        <td> {fee.discount ? `₹${fee.discount}` : ''} </td>
                        <td>
                          {fee.payment_method
                            ? fee.payment_method.charAt(0).toUpperCase() +
                              fee.payment_method.slice(1)
                            : 'N/A'}
                        </td>

                        <td>
                          {fee.transaction_date
                            ? new Date(fee.transaction_date).toLocaleDateString(
                                'en-GB',
                                {
                                  day: '2-digit',
                                  month: 'long',
                                  year: 'numeric',
                                },
                              )
                            : null}
                        </td>
                        <td>
                          <span
                            className="fw-bold"
                            style={{
                              backgroundColor:
                                fee.fees_status === 'complete'
                                  ? '#d1fae5'
                                  : '#fef3c7', // green or yellow background
                              color:
                                fee.fees_status === 'complete'
                                  ? '#065f46'
                                  : '#92400e', // dark green or dark orange text
                              padding: '4px 10px',
                              borderRadius: '20px',
                              fontSize: '0.875rem',
                              fontWeight: 600,
                              textTransform: 'capitalize',
                            }}
                          >
                            {fee.fees_status}
                          </span>
                        </td>
                        {/* <td>
                          <button onClick={()=>{
                            console.log("Selected fees id for edit:", fee.id)
                            setSelectedTransactionId(fee.id)
                            setOpenEditModal(true)
                          }} title="Edit Fees" className='btn btn-warning' variant="warning">
                            <FaEdit  />
                          </button>
                        </td> */}

                        {/* <td className="text-end">
                      {fee.fees_status === 'complete' &&
                        (selectedFees.length > 1 ? (
                          // Show print button only on the first selected row
                          selectedFees[0] === fee.id && (
                            <button
                              title="Print Selected"
                              onClick={handlePrint}
                              className="btn btn-sm btn-primary "
                            >
                              <FaPrint />
                            </button>
                          )
                        ) : (
                          // Show individual print button for single selection
                          <button
                            title="Print"
                            onClick={() => handlePrint(fee)}
                            className="btn btn-sm btn-primary"
                          >
                            <FaPrint />
                          </button>
                        ))}
                    </td> */}
                      </tr>
                    ))
                )}
              </tbody>
            </Table>
          </div>
        )}
      </div>
      <EditTransactionModal show={openEditModal}
        data={selectedData}
        selectedId={selectedTransactionId}
      onHide={()=>setOpenEditModal(false)} 
      onUpdate={fetchStudentFeeData}
        />
    </>
  )
}
